import React, { useEffect } from 'react';
import { StartOnboarding as View } from '@views';
import { trackEvent } from '@utils/mixpanel';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

const StartOnboarding = () => {
  const location = useLocation();
  const { currentLocation } = useSelector(store => store.locationStore);

  useEffect(() => {
    const pageTitle = 'Mindspace: Welcome';
    document.title = pageTitle;

    window.gtag('event', 'page_view', {
      page_title: pageTitle,
    });

    trackEvent('Page Viewed', {
      Page: 'Welcome - Onboarding',
    });
  }, []);

  return <View direction={location?.state?.direction} location={currentLocation?.title} />;
};

export default StartOnboarding;
